import React from 'react'
import StateBadge from 'components/StateBadge'

const BulkStateBadge = ({
  commonStateForSelected,
  count,
  onStateBadgeClick,
  variant,
}) => {
  const commonState = commonStateForSelected || 'open'
  return (
    <StateBadge
      onClick={onStateBadgeClick(commonState, count)}
      state={commonState}
      label={commonState}
      variant={variant}
    />
  )
}

export default BulkStateBadge
